export enum AISummaryEligibility {
    GENERATION = 'GENERATION', // Summary was generated for internal use only
    VISIBILITY = 'VISIBILITY', // Summary can be shown
    NOT_ELIGIBLE = 'NOT_ELIGIBLE', // Summary can't be shown due to multiple reasons (gig is on hold, seller is not active, etc.)
}
